
export const API_BASE_URL= process.env.REACT_APP_API_BASE_URL?.trim() || ""
export const Image_Url= process.env.REACT_APP_API_BASE_URL || ""
